import { useMediaQuery, useTheme } from '@mui/material';

/**
 * Returns a responsive columnHeaderHeight for DataGridPro based on screen size.
 * Scales down the base (md+) height for smaller breakpoints.
 */
export const useResponsiveHeaderHeight = (baseHeight: number): number => {
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
    const isMedium = useMediaQuery(theme.breakpoints.between('sm', 'md'));

    if (isSmall) return Math.round(baseHeight * 0.7);
    if (isMedium) return Math.round(baseHeight * 0.85);
    return baseHeight;
};
